/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchOperators
 */
export interface SearchOperators {
    /**
     * 
     * @type {boolean}
     * @memberof SearchOperators
     */
    equals: boolean;
}

/**
 * Check if a given object implements the SearchOperators interface.
 */
export function instanceOfSearchOperators(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "equals" in value;

    return isInstance;
}

export function SearchOperatorsFromJSON(json: any): SearchOperators {
    return SearchOperatorsFromJSONTyped(json, false);
}

export function SearchOperatorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchOperators {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'equals': json['equals'],
    };
}

export function SearchOperatorsToJSON(value?: SearchOperators | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'equals': value.equals,
    };
}

